import React from 'react';
import { createRoot } from 'react-dom/client';

import Routes from './routes';

import { Provider } from 'react-redux'
import createStore from './store'

import './index.css'

const store = createStore();

// Create a root
const root = createRoot(document.getElementById('root'));

// Register a service worker that uses network-first for the app shell (/, index.html) so every
// load gets the latest HTML/JS. The browser checks for SW updates with no-cache; when we deploy
// a new SW, it takes over and existing users get the new frontend on next load without hard refresh.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}

root.render(
  <Provider store={store}>
    <Routes/>
  </Provider>
);
